import React, { useState, useEffect } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import Dialog from 'react-toolbox/lib/dialog'
import T from 'i18n-react'
import { compose } from 'recompose'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'
import { Flex } from 'reflexbox' 

import Table from '../Table'
import Divider from 'components/fulcrum/divider/Divider'

import styles from './styles.scss'

const SelectProfileDialog = ({active, toggleActive, onSave, initConfig, testProfiles, fetchTestProfiles}) => {
  const [modifiedConfig, setModifiedConfig] = useState(initConfig)
  const [testList, setTestList] = useState([])
  const { greenLightProfileName, nvqualProfileName } = modifiedConfig
  const { greenLightProfiles, nvqualProfiles } = testProfiles

  useEffect(() => {
    if (active) fetchTestProfiles()
  }, [active])

  useEffect(() => {
    setModifiedConfig(initConfig)
  }, [initConfig])

  useEffect(() => {
    setTestList(getTests())
  }, [modifiedConfig, testProfiles])

  const getTests = () => {
    const greenLightProfile = greenLightProfiles.find(profile => profile.profileName === greenLightProfileName)
    const nvqualProfile = nvqualProfiles.find(profile => profile.profileName === nvqualProfileName)
    return [
      ...(greenLightProfile ? greenLightProfile.tests : []),
      ...(nvqualProfile ? nvqualProfile.tests: []),
    ]
  }

  const onCancel = () => {
    setModifiedConfig(initConfig)
    toggleActive()
  }

  const saveDisabled = (
    greenLightProfileName === initConfig.greenLightProfileName &&
    nvqualProfileName === initConfig.nvqualProfileName
  )
  
  const actions = [
      { label: 'Save', onClick: () => onSave(modifiedConfig), disabled: saveDisabled },
      { label: 'Cancel', onClick: onCancel },
  ]

  const getDropdownSource = (profiles) => [
    ...profiles.map(profile => ({
      value: profile.profileName,
      label: profile.profileLabel,
    })),
    {
      value: '',
      label: 'Disabled'
    }
  ]

  const emptyTestListMessage = (
    <div styleName='emptyStateMessage'>
      {T.translate('containers.product.fulcrumTestSuiteConfiguration.dialog.emptyTestListMessage')}
    </div>
  )

  const showEmptyTestProfilesMessage = !greenLightProfiles.length && !nvqualProfiles.length && (
    <div styleName='emptyStateMessage'>
      {T.translate('containers.product.fulcrumTestSuiteConfiguration.dialog.emptyTestProfilesMessage')}
    </div>
  )

  return (
    <Dialog
      active={active}
      onEscKeyDown={toggleActive}
      onOverlayClick={toggleActive}
      actions={actions}
      title={T.translate('containers.product.fulcrumTestSuiteConfiguration.dialog.title')}
      theme={styles}
      styleName='dialogContainer'
    >
      <div styleName='parentContainer'>
        <div styleName='leftContainer'>
          <div styleName='dialogSection'>
            <div>{T.translate('containers.product.fulcrumTestSuiteConfiguration.dialog.greenLightSelection')}</div>
            <Dropdown
              value={greenLightProfileName} 
              source={getDropdownSource(greenLightProfiles)} 
              onChange={(value) => setModifiedConfig({ ...modifiedConfig, greenLightProfileName: value})}
            />
          </div>
          <div styleName='dialogSection'>
            <div>{T.translate('containers.product.fulcrumTestSuiteConfiguration.dialog.nvqualSelection')}</div>
            <Dropdown
              value={nvqualProfileName} 
              source={getDropdownSource(nvqualProfiles)} 
              onChange={(value) => setModifiedConfig({ ...modifiedConfig, nvqualProfileName: value})}
            />
          </div>
          {showEmptyTestProfilesMessage}
        </div>
        <div styleName='rightContainer'>
          <div styleName='containerHeader'>
            <h6>{T.translate('containers.product.fulcrumTestSuiteConfiguration.dialog.testProfileConfiguration')}</h6>
          </div>
          <div styleName='tableSection'>
            {
              testList.length ? (
                <Table
                  source={testList}
                />
              ) : emptyTestListMessage
            }
          </div>
        </div>
      </div>
    </Dialog>
  )
}


const withStyle = CSSModules(styles)
const enhance = compose(withStyle)
export default enhance(SelectProfileDialog)